document.addEventListener('DOMContentLoaded', () => {
  const discoverHeader = document.querySelector('.discover-header img');

  var textAnims = document.querySelectorAll('.new-landing-cta');
  function autoPlayTextAnims() {
    textAnims.forEach((anim) => {
      if (isElementVisible(anim) && !anim.classList.contains('started')) {
        anim.classList.add('started');

        const phrases = anim.querySelectorAll('.cta-phrase');
        var interval = 1000;
        var c = phrases.length;
        var isFirst = true;
        phrases.forEach((phrase, idx) => {
          setTimeout(() => {
            phrases.forEach((phrase, idx) => {
              phrase.classList.remove('cta-animate-text');
              phrase.classList.remove('cta-animate-text-first');
              phrase.classList.remove('first-phrase');
            });
            if (idx < c - 1) {
              if (idx === 0) {
                phrase.classList.add('cta-animate-text-first');
              } else {
                phrase.classList.add('cta-animate-text');
              }
            } else {
              phrase.classList.add('cta-animate-text-last');
            }
          }, interval);
          if (isFirst) {
            interval = 1800;
            isFirst = false;
          } else {
            interval = 1700 * (idx + 1) + 100;
          }
        });
      }
    });
  }
  autoPlayTextAnims();
  document.addEventListener('scroll', autoPlayTextAnims);

  var duration = 400;

  var container = document.getElementById('landing-page-features-slider-outer');
  var scroller = document.getElementById('landing-page-features-slider-scroll');

  var items, firstItem, firstRect, currentItem, rect, calculatedAmount, offset;
  var counter = 0;
  var numberOfItems = 0;
  var inc = 1;
  var defaultOffset = 12;
  var isAnimating = false;

  var lefts = [];
  setTimeout(() => {
    setUp();
  }, 1000);

  $(window).resize(setUp);
  function setUp() {
    if (container && scroller) {
      items = scroller.querySelectorAll('ul.track li');
      counter = 0;
      numberOfItems = items.length;
      scroller.scrollLeft = 0;
      firstItem = items[0];
      firstRect = firstItem.getBoundingClientRect();
      currentItem = items[1];
      rect = currentItem.getBoundingClientRect();
      calculatedAmount = firstRect.width;

      inc = Math.floor(window.innerWidth / rect.width);

      if (inc < 1) inc = 1;
      checkArrows();
      lefts = [];
      // for (i = 1; i <= items.length; i++) {
      //   var c = document.getElementById('slide-' + i);
      //   var r = c.getBoundingClientRect();
      //   lefts.push(r.left);
      // }
      items.forEach(function (item) {
        var r = item.getBoundingClientRect();
        lefts.push(r.left);
      });
    }
  }

  var xDown = null;
  var yDown = null;

  if (scroller) {
    scroller.addEventListener('touchstart', handleFeaturesTouchStart, {
      passive: true,
    });
    scroller.addEventListener('touchmove', handleFeaturesTouchMove, {
      passive: true,
    });
  }

  function getTouches(evt) {
    return (
      evt.touches || // browser API
      evt.originalEvent.touches
    ); // jQuery
  }

  function handleFeaturesTouchStart(e) {
    const firstTouch = getTouches(e)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  function handleFeaturesTouchMove(e) {
    if (!xDown) return;

    var xUp = e.touches[0].clientX;
    var yUp = e.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        $('#landing-page-features-slider-next').click();
      } else {
        $('#landing-page-features-slider-prev').click();
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
      } else {
        /* down swipe */
      }
    }

    featuresXDown = null;
    featuresYDown = null;
  }

  $('#landing-page-features-slider-next').click(function () {
    if (!isAnimating) {
      var lastCount = counter;
      if (counter === 0) {
        counter = 1;
      } else {
        counter = counter + inc;
      }

      if (counter > numberOfItems) counter = lastCount;

      isAnimating = true;

      $('#landing-page-features-slider-scroll').animate(
        {
          scrollLeft: lefts[counter],
        },
        duration,
        function () {
          checkArrows();
          isAnimating = false;
        }
      );
    }
  });

  $('#landing-page-features-slider-prev').click(function () {
    if (!isAnimating) {
      counter = counter - inc;

      if (counter < 0) counter = 0;
      isAnimating = true;
      $('#landing-page-features-slider-scroll').animate(
        {
          scrollLeft: lefts[counter],
        },
        duration,
        function () {
          checkArrows();
          isAnimating = false;
        }
      );
    }
  });

  function checkArrows() {
    var nextOpacity = 1;
    var nextCursor = 'pointer';
    var nextDisabled = false;

    var w = scroller.scrollWidth - scroller.scrollLeft - window.innerWidth;
    /*     console.log(
      'w2',
      scroller.scrollWidth - scroller.scrollLeft - window.innerWidth
    );
 */
    if (w < 100) {
      nextOpacity = 0;
      nextCursor = 'initial';
      nextDisabled = true;
    }

    $('#landing-page-features-slider-next')
      .css({
        opacity: nextOpacity,
        cursor: nextCursor,
      })
      .prop('disabled', nextDisabled);

    var prevOpacity = 0;
    var prevCursor = 'initial';
    var prevDisabled = true;

    if (scroller.scrollLeft > 0) {
      var prevOpacity = 1;
      var prevCursor = 'pointer';
      prevDisabled = false;
    }

    $('#landing-page-features-slider-prev')
      .css({
        opacity: prevOpacity,
        cursor: prevCursor,
      })
      .prop('disabled', prevDisabled);
  }
});

function isElementVisible(el) {
  var r, html;
  if (!el || 1 !== el.nodeType) {
    return false;
  }
  html = document.documentElement;
  r = el.getBoundingClientRect();

  return (
    !!r &&
    r.bottom >= 0 &&
    r.right >= 0 &&
    r.top <= html.clientHeight &&
    r.left <= html.clientWidth
  );
}
